
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kit/[slug]",
      function () {
        return require("private-next-pages/kit/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kit/[slug]"])
      });
    }
  